import moment from "moment";
import React from "react";
import {
	TORB3BackendRecord,
	TORB3Record,
} from "../../../../../redux/app/orb3/@types";
import { TORB3GroupA4 } from "../../../../../redux/app/orb3/groups/group-a";
import ORB3TableRows, { renderDataTable } from "../ORB3TableRows";

const ODS_COLUMNS = [
	{ key: "equipment", label: "ODS Equipment" },
	{ key: "substance", label: "Discharge Substance" },
	{ key: "quantityKg", label: "Discharge Qty (kgs)" },
];

type OwnProps = {
	orb3Record: TORB3Record | TORB3BackendRecord;
	theme?: "light" | "dark";
};
type ORB3GroupA4PreviewProps = OwnProps;

function ORB3GroupA4Preview(props: ORB3GroupA4PreviewProps) {
	const record = props.orb3Record as TORB3GroupA4;
	const operationDate = moment(record.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY",
	);
	const { itemA4 } = record;

	function renderItemP1() {
		const startDTLocal = `${itemA4.startDate}T${itemA4.startTime}:00${record.timeZone}`;
		const utcStart = moment.utc(startDTLocal);
		const stopDTLocal = `${itemA4.stopDate}T${itemA4.stopTime}:00${record.timeZone}`;
		const utcStop = moment.utc(stopDTLocal);
		return (
			<>
				<h4 className="font-medium uppercase">
					Start: {utcStart.format("HH:mm")} hrs UTC on{" "}
					{utcStart.format("DD-MMM-YYYY")} ({itemA4.startTime} SMT on{" "}
					{moment(itemA4.startDate, "YYYY-MM-DD").format("DD-MMM-YYYY")})
				</h4>
				<h4 className="font-medium uppercase">
					Stop: {utcStop.format("HH:mm")} hrs UTC on{" "}
					{utcStop.format("DD-MMM-YYYY")} ({itemA4.stopTime} SMT on{" "}
					{moment(itemA4.stopDate, "YYYY-MM-DD").format("DD-MMM-YYYY")})
				</h4>
			</>
		);
	}

	function renderMain() {
		return (
			<ORB3TableRows
				record={record}
				tableRows={[
					[operationDate, "3-A", "1.4", renderItemP1()],
					[
						null,
						null,
						"-",
						itemA4.vesselPositionType === "PORT"
							? `Port: ${itemA4.portName}`
							: `Position: ${itemA4.latitude} / ${itemA4.longitude}`,
					],
					[null, null, "-", renderDataTable(itemA4.items, ODS_COLUMNS)],
					[
						null,
						null,
						"NOTE",
						itemA4.receiptAttachment
							? `Receipt: ${itemA4.receiptAttachment}`
							: "",
					],
					[null, null, "NOTE", record.remarks],
				]}
				theme={props.theme}
			/>
		);
	}

	return renderMain();
}

export default ORB3GroupA4Preview;
